'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@7f-ui/components/button/button';
import { SimpleModal } from '@7f-ui/components/modal/simple-modal';
import { formatGermanNumber } from '@utils/utils-format';
import { useId, useState } from 'react';
import { useAppExperienceReviews } from 'src/app/erlebnisse/_hooks/use-app-experience-reviews';
import type { ProductReview, ProductReviewSummary } from 'src/lib/trusted-shops/product-reviews';
import { ExperienceReviewCard } from 'src/shared/composites/trusted-shops/experience-review-card';
import { ExperienceReviewSummary, ExperienceReviewSummaryBar } from './experience-review-summary';
const PREVIEW_REVIEWS = 3;
export function ExperienceReviews(t0) {
  const $ = _c(51);
  const {
    publicId,
    reviewSummary,
    isOpen,
    onOpen,
    onClose
  } = t0;
  const [selected, setSelected] = useState(null);
  const [limit, setLimit] = useState(10);
  const {
    data
  } = useAppExperienceReviews(publicId);
  const summaryData = data ?? reviewSummary;
  if (!summaryData?.count) {
    return null;
  }
  let t1;
  if ($[0] !== data?.reviews) {
    t1 = data?.reviews ?? [];
    $[0] = data?.reviews;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const reviews = t1;
  let close;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== onClose || $[3] !== onOpen || $[4] !== reviews || $[5] !== summaryData) {
    const previewReviews = reviews.slice(0, PREVIEW_REVIEWS);
    let t10;
    if ($[15] !== onClose) {
      t10 = () => {
        onClose();
        setSelected(null);
        setLimit(10);
      };
      $[15] = onClose;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    close = t10;
    t6 = "py-8";
    t7 = "experience-reviews-heading";
    t8 = "experience-reviews";
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <h2 className="mb-6 font-heading2 sm:mb-4" id="experience-reviews-heading">Das sagen Gäste</h2>;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    t2 = "grid min-w-0 gap-4 sm:gap-3";
    if ($[18] !== summaryData) {
      t3 = <div className="sm:hidden"><ExperienceReviewSummary data={summaryData} /></div>;
      $[18] = summaryData;
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    if ($[20] !== summaryData) {
      t4 = <div className="hidden sm:block"><ExperienceReviewSummaryBar data={summaryData} /></div>;
      $[20] = summaryData;
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    t5 = previewReviews.length > 0 && <ul className="grid min-w-0 gap-4 sm:gap-3">{previewReviews.map((review, index) => <li key={review.id}><ExperienceReviewButton review={review} number={index + 1} onOpen={() => {
          setSelected(review);
          onOpen();
        }} /></li>)}</ul>;
    $[2] = onClose;
    $[3] = onOpen;
    $[4] = reviews;
    $[5] = summaryData;
    $[6] = close;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    close = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5) {
    t10 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== onOpen || $[28] !== reviews.length || $[29] !== summaryData) {
    t11 = reviews.length > 0 && <Button variant="secondary" classNames={{
      root: "mt-4 w-full sm:mt-3 sm:w-auto"
    }} onClick={() => {
      setSelected(null);
      onOpen();
    }}>{summaryData.count === 1 ? "Bewertung anzeigen" : `Alle ${formatGermanNumber(summaryData.count)} Bewertungen anzeigen`}</Button>;
    $[27] = onOpen;
    $[28] = reviews.length;
    $[29] = summaryData;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const t12 = selected ? "G\xE4stestimme" : "Das sagen G\xE4ste";
  const t13 = selected ? "auto" : "full";
  const t14 = !selected;
  let t15;
  if ($[31] !== limit || $[32] !== reviews || $[33] !== selected || $[34] !== summaryData) {
    t15 = selected ? <ExperienceReviewCard authorName="Community Mitglied" rating={selected.rating} submittedAt={selected.submittedAt} text={selected.comment} /> : <div className="grid gap-4"><ExperienceReviewSummary data={summaryData} />{reviews.slice(0, limit).map(_temp)}{limit < reviews.length && <Button variant="secondary" onClick={() => setLimit(_temp2)}>Mehr anzeigen</Button>}</div>;
    $[31] = limit;
    $[32] = reviews;
    $[33] = selected;
    $[34] = summaryData;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== close || $[37] !== isOpen || $[38] !== t12 || $[39] !== t13 || $[40] !== t14 || $[41] !== t15) {
    t16 = <SimpleModal isOpen={isOpen} onClose={close} title={t12} size="medium" height={t13} fullScreenOnMobile={t14}>{t15}</SimpleModal>;
    $[36] = close;
    $[37] = isOpen;
    $[38] = t12;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t10 || $[44] !== t11 || $[45] !== t16 || $[46] !== t6 || $[47] !== t7 || $[48] !== t8 || $[49] !== t9) {
    t17 = <section className={t6} aria-labelledby={t7} id={t8}>{t9}{t10}{t11}{t16}</section>;
    $[43] = t10;
    $[44] = t11;
    $[45] = t16;
    $[46] = t6;
    $[47] = t7;
    $[48] = t8;
    $[49] = t9;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  return t17;
}
function _temp2(value) {
  return value + 10;
}
function _temp(review_0) {
  return <ExperienceReviewCard key={review_0.id} authorName="Community Mitglied" rating={review_0.rating} submittedAt={review_0.submittedAt} text={review_0.comment} />;
}
function ExperienceReviewButton(t0) {
  const $ = _c(23);
  const {
    review,
    number,
    onOpen
  } = t0;
  const id = useId();
  const ratingId = `${id}-rating`;
  const commentId = `${id}-comment`;
  const actionId = `${id}-action`;
  let t1;
  if ($[0] !== review.comment) {
    t1 = review.comment.trim();
    $[0] = review.comment;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const comment = t1;
  const t2 = `${ratingId} ${actionId}`;
  const t3 = comment ? commentId : undefined;
  const t4 = `${review.rating} von 5 Sternen`;
  let t5;
  if ($[2] !== ratingId || $[3] !== t4) {
    t5 = <span id={ratingId} className="sr-only">{t4}</span>;
    $[2] = ratingId;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = `Bewertung ${number} öffnen`;
  let t7;
  if ($[5] !== actionId || $[6] !== t6) {
    t7 = <span id={actionId} className="sr-only">{t6}</span>;
    $[5] = actionId;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== comment || $[9] !== commentId) {
    t8 = comment ? <span id={commentId} className="sr-only">{comment}</span> : null;
    $[8] = comment;
    $[9] = commentId;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== comment || $[12] !== review.rating || $[13] !== review.submittedAt) {
    t9 = <ExperienceReviewCard authorName="Community Mitglied" rating={review.rating} submittedAt={review.submittedAt} text={comment} clamp={true} />;
    $[11] = comment;
    $[12] = review.rating;
    $[13] = review.submittedAt;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== onOpen || $[16] !== t2 || $[17] !== t3 || $[18] !== t5 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <button type="button" onClick={onOpen} aria-labelledby={t2} aria-describedby={t3} className="relative block w-full min-w-0 rounded-2xl text-left sm:rounded-lg text-primary focus-visible:outline-2 focus-visible:outline-primary">{t5}{t7}{t8}{t9}</button>;
    $[15] = onOpen;
    $[16] = t2;
    $[17] = t3;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}